export const LaborCostDetailsRouting = [
  {
    path: "/report-center/download/labor-cost-details/list",
    name: "material-labor-cost-details-list",
    meta: { title: "劳务费用明细表" },
    component: () =>
      import(
        /* webpackChunkName: "library-report" */ "@/views/report-center/labor-cost-details/list/index.vue"
      ),
  },
];
